import React from "react";
import { Modal, Button } from "react-bootstrap";
import RemoveFromDeletedNode from "../data/Firebase/RemoveUserfromDeletedNode";

export const DeletedAccountModal = ({ userID, show, onHide, onRollback, setIsLoading }) => {


    const handleRollback = () => {
        setIsLoading(true);
        onRollback();
        RemoveFromDeletedNode(userID)
            .then(() => {
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error restoring account:", error);
                // setIsLoading(false);

            });
    };

    
    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="w-100 text-center fw-bold fs-4">
                    Restore Account
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
                <p className="text-muted fs-6 mb-2">
                    We noticed that your account was previously deleted.
                </p>
                <p className="fw-semibold fs-5">
                    Would you like to restore your account and get back your previous data?
                </p>
            </Modal.Body>

            <Modal.Footer className=" border-0 pt-0">
                <Button variant="outline-secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleRollback}>
                    Restore
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
